export default __webpack_public_path__ + "static/media/logo.3d7b7532.svg";